export default __webpack_public_path__ + "static/media/Start Kit 10k.c9f672f5.jpg";